import React, { Component } from 'react';
import { Analytics } from '../../utils/common/analytics.js';

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
		this.analytics = Analytics.getInstance();
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return {
			hasError: true,
			error,
		};
	}

	componentDidCatch(error, errorInfo) {
		this.analytics.addEvent(Analytics.eventType.ERROR, {
			errorDesc: `${error?.name}: ${error?.message}`,
		});
	}

	render() {
		const { hasError, error } = this.state;

		if (hasError) {
			// You can render any custom fallback UI
			return <div className="text-center">{Granite.I18n.get('Something went wrong')}</div>;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
